export default "__VITE_ASSET__D8cdLe0I__"